import blueBadge from "../assets/badges/blue.png";
import greenBadge from "../assets/badges/green.png";
import redBadge from "../assets/badges/red.png";
import yellowBadge from "../assets/badges/yellow.png";
import "./PlayerBadge.css";

interface PlayerBadgeProps {
  color: string | null;
}

const BADGE_IMAGES: Record<string, string> = {
  blue: blueBadge,
  green: greenBadge,
  red: redBadge,
  yellow: yellowBadge,
};

export function PlayerBadge({ color }: PlayerBadgeProps) {
  if (!color || !BADGE_IMAGES[color]) {
    return null;
  }

  return (
    <div className="player-badge">
      <img src={BADGE_IMAGES[color]} alt={`${color} player badge`} />
    </div>
  );
}
